import React from 'react'
import './services.css'
import {TiTickOutline} from 'react-icons/ti'
const services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className='service'>
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className="service__list">
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Visual design.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Interaction design.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Information architecture.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Responsive design and cross-device compatibility.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Design systems and style guides.</p>
            </li>
            
          </ul>
        </article>
        {/* END OF UX/UI */}
        <article className='service'>
          <div className="service__head">
            <h3>Web Develoment</h3>
          </div>
          <ul className="service__list">
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Website design and development.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>E-commerce website development.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Custom web application development.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Responsive web design.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Website maintenance and support.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Website performance optimization.</p>
            </li>
            
          </ul>
        </article>
        {/* END OF WEB DEVELOPMENT */}
        <article className='service'>
          <div className="service__head">
            <h3>Content Creation</h3>
          </div>
          <ul className="service__list">
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Interactive tools/widgets.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Infographics.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Open source projects.</p>
            </li>
            <li>
            <TiTickOutline className='service__list-icon'/>
            <p>Code snippets.</p>
            </li>
            
          </ul>
        </article>
        {/* END OF CONTENT CREATION */}
      </div>


    </section>
  )
}

export default services
